import React from "react";
import PageBanner from "./servicesBanner/pageBanner";
import CounterSection from "./counterSection/counterSection";   
import WebDevelopment from "./ServicesInfo/webDevelopment";
import MobileAppDevelopment from "./ServicesInfo/mobileAppDevelopment";
import UIDesign from "./ServicesInfo/UIDesign";
import DigitalMarketing from "./ServicesInfo/digitalMarketing";
import CallCentre from "./ServicesInfo/callCenter";
import LeadGeneration from "./ServicesInfo/leadGeneration";
import CustomerFeedBack from "../homePage/customerFeedBack/customerFeedBack";
import LinkedinOutReach from "./ServicesInfo/linkedinOutreach";
import EmailOutreach from "./ServicesInfo/emailOutreach";
import SocialMediaOutreach from "./ServicesInfo/socialMediaOutreach";



function ServicesPage(){
    return(
        <div>
            <PageBanner />
            <CounterSection />
            {/* <LeadGeneration /> */}
            <LinkedinOutReach />
            <EmailOutreach />
            <SocialMediaOutreach />
            <WebDevelopment  />
            <MobileAppDevelopment />
            <UIDesign />
            <DigitalMarketing />
            {/* <CallCentre /> */}
            <CustomerFeedBack />
        </div>
    )
}


export default ServicesPage;